import { Money, Paid, People } from "@mui/icons-material";
import { Avatar, Backdrop, Box, CircularProgress, Container, Divider, List, ListItem, ListItemAvatar, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PartnerService } from "../services/PartnerService";
import { CurrentUser } from "../models/CurrentUser";
import { Partner } from "../models/Partner";
import { WebStorageService } from "../services/WebStorageService";
import { CURRENT_USER } from "../contants/constants";
import { Utils } from "../helpers/utils";

export default function MyProfile() {
    const webStorageService = new WebStorageService();
    const partnerService: PartnerService = new PartnerService();
    const [user, setUser] = useState<CurrentUser>(webStorageService.getJson(CURRENT_USER));
    const [partner, setPartner] = useState<Partner>(new Partner());
    const [isValidating, setIsValidating] = useState(false);

    useEffect(() => {
        setIsValidating(true);
        partnerService.Get(Number(user.ID)).then(response => {
            if(response.Data != undefined)
                setPartner(response.Data);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setIsValidating(false);
        });
    }, []);


    return (
        <Container sx={{ alignItems: "baseline", flexDirection: "column", paddingTop: 15 }}>
            <Backdrop open={isValidating} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>
            <Typography variant="h5" sx={{ marginBottom: 2 }}>My Profile</Typography>
            <Paper sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f5e7e7" }}>
                <Box sx={{display:'flex', flexDirection:"column", justifyContent:"space-between"}}>
                    <Typography variant="subtitle1" color="#999999" sx={{ marginBottom: 1 }}>Personal Details</Typography>
                    <Typography variant="subtitle2" color="primary">Name</Typography>
                    <Typography variant="subtitle1">{partner?.ContactPerson}</Typography>
                    
                    <br></br>
                    <Typography variant="subtitle2" color="primary">Business Name</Typography>
                    <Typography variant="subtitle1">{partner?.BusinessName}</Typography>
                    
                    <br></br>
                    <Typography variant="subtitle2" color="primary">Primary Mobile Number (username)</Typography>
                    <Typography variant="subtitle1">{partner?.Mobile1}</Typography>

                    <br></br>
                    <Typography variant="subtitle2" color="primary">Address</Typography>
                    <Typography variant="subtitle1">{partner?.Address}</Typography>
                </Box>
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f5e7e7" }}>
                <Typography variant="subtitle1" color="#999999" sx={{ marginBottom: 1 }}>Payout Information</Typography>
                <Typography variant="subtitle2" color="primary">GCash Account Number</Typography>
                <Typography variant="subtitle1">{partner?.GcashNo}</Typography>
                <br></br>

                <Typography variant="subtitle2" color="primary">GCash Account Name</Typography>
                <Typography variant="subtitle1">{partner?.GcashAccountName}</Typography>
                <br></br>
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f5e7e7" }}>
                <Typography variant="subtitle1" color="#999999" sx={{ marginBottom: 1 }}>Referral Fees</Typography>
                
                <Typography variant="subtitle2" color="primary">Referral Fee 50kg</Typography>
                <Typography variant="subtitle1">{Utils.formatNumber(partner?.ReferralFee50kg)}</Typography>
                <br></br>

                <Typography variant="subtitle2" color="primary">Referral Fee 22kg</Typography>
                <Typography variant="subtitle1">{Utils.formatNumber(partner?.ReferralFee22kg)}</Typography>
                <br></br>

                <Typography variant="subtitle2" color="primary">Referral Fee 11kg</Typography>
                <Typography variant="subtitle1">{Utils.formatNumber(partner?.ReferralFee11kg)}</Typography>
                <br></br>

                <Typography variant="subtitle2" color="primary">Referral Fee 5kg</Typography>
                <Typography variant="subtitle1">{Utils.formatNumber(partner?.ReferralFee5kg)}</Typography>
                <br></br>

                <Typography variant="subtitle2" color="primary">Referral Fee 2.7kg</Typography>
                <Typography variant="subtitle1">{Utils.formatNumber(partner?.ReferralFee2_7kg)}</Typography>
                <br></br>
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f5e7e7" }}>
                <Typography variant="subtitle1" color="#999999" sx={{ marginBottom: 1 }}>Affiliation</Typography>

                <Typography variant="subtitle2" color="primary">Affiliated Store</Typography>
                <Typography variant="subtitle1">{partner?.StoreName}</Typography>
                <br></br>
            </Paper>

        </Container>
    );
}